import { Form, FormInstance } from 'antd';
import { Dispatch, FC, ReactNode, SetStateAction, useState } from 'react';

import { PrimaryMarketCreateFilter } from 'pages/Account/Invest/PrimaryMarket/PrimaryMarketFilter/PrimaryMarketCreateFilter';
import { SubmitButton } from 'componets/form';

import { FieldData, IFilter, IFilterValues, ISavedFilter } from 'models';

import { useTranslate } from 'hooks';

import styles from './index.module.scss';

interface FiltersFormProps {
	onFinish: () => void;
	setFields: (changedFields: FieldData[], allFields?: FieldData[]) => void;
	form: FormInstance;
	initialValues: IFilterValues;
	fields: FieldData[];
	setActiveFilter?: Dispatch<SetStateAction<ISavedFilter>>;
	children: ReactNode;
	values?: IFilterValues;
	filters: IFilter[];
	isPrimary?: boolean;
}

export const FiltersForm: FC<FiltersFormProps> = ({
	onFinish,
	setFields,
	form,
	initialValues,
	fields,
	setActiveFilter,
	children,
	values,
	filters,
	isPrimary,
}) => {
	const { applyText, saveText } = useTranslate(['applyText', 'saveText']);

	const [isOpenSave, setIsOpenSave] = useState(false);
	return (
		<Form
			onFinish={onFinish}
			onFieldsChange={(v) => {
				if (setActiveFilter) {
					setActiveFilter({} as ISavedFilter);
				}

				setFields(v);
			}}
			fields={fields}
			form={form}
			initialValues={initialValues}
		>
			{children}

			<div className={styles.filterButtons}>
				<div className={styles.filterButtonsWrapper}>
					<SubmitButton
						text={applyText}
						classNameWrapper={styles.submitWrapper}
						className={styles.submit}
					/>
					{filters.length > 0 && isPrimary && (
						<div role="button" className="white-btn" onClick={() => setIsOpenSave(true)}>
							{saveText}
						</div>
					)}
				</div>
			</div>

			<PrimaryMarketCreateFilter
				isOpen={isOpenSave}
				onClose={() => setIsOpenSave(false)}
				values={values as IFilterValues}
			/>
		</Form>
	);
};
